import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import EmailIcon from "@mui/icons-material/Email";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import LocationOnIcon from "@mui/icons-material/LocationOn";

export default function Profile() {
  return (
    <>
      <Grid container spacing={2} sx={{ mt: 4, px: 2 }}>
        {/* Left Column: Contact Info */}
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h6" align="left">
                P Kumar
              </Typography>
              <Divider sx={{ mt: 2, mb: 2 }} />

              <Stack direction="row" spacing={2} alignItems="center" mb={2}>
                <EmailIcon />
                <Typography variant="body2">code@codemstr.com</Typography>
              </Stack>
              <Divider />
              <Stack direction="row" spacing={2} alignItems="center" my={2}>
                <SmartphoneIcon />
                <Typography variant="body2">(+91) 99999 99999</Typography>
              </Stack>
              <Divider />
              <Stack direction="row" spacing={2} alignItems="center" mt={2}>
                <LocationOnIcon />
                <Typography variant="body2">Patna, India</Typography>
              </Stack>
            </CardContent>
          </Card>
        </Grid>

        {/* Right Column: About & Details */}
        <Grid item xs={12} md={8}>
          <Card>
            <CardContent>
              <Typography variant="h6" align="left">
                About me
              </Typography>
              <Divider sx={{ mt: 2 }} />
              <Typography variant="body2" sx={{ mt: 2 }}>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quos
                blanditiis tenetur unde suscipit, quam beatae rerum inventore
                consectetur, neque doloribus, cupiditate numquam dignissimos
                laborum fugiat deleniti? Eum quasi quidem quibusdam.
              </Typography>

              <Typography variant="h6" align="left" sx={{ mt: 4 }}>
                Details
              </Typography>
              <Divider sx={{ mt: 2, mb: 2 }} />

              {[
                ["Full Name:", "Albert Einstein"],
                ["Father's Name:", "Sr. Albert Einstein"],
                ["Address:", "Patna, India"],
                ["Zip Code:", "809990"],
                ["Website:", "https://trickuweb.com"],
              ].map(([label, value], index) => (
                <Box key={index} sx={{ mb: 2 }}>
                  <Stack direction="row" spacing={2}>
                    <Typography
                      variant="subtitle2"
                      sx={{ width: "140px", flexShrink: 0 }}
                    >
                      {label}
                    </Typography>
                    <Typography variant="body2" sx={{ wordBreak: "break-word" }}>
                      {value}
                    </Typography>
                  </Stack>
                  {index !== 4 && <Divider sx={{ mt: 1 }} />}
                </Box>
              ))}
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Box height={20} />
    </>
  );
}
